var _a;
import { DropShadowFilter } from './DropShadowFilter';
import { GlowFilter } from './GlowFilter';
import { BevelFilter } from './BevelFilter';
import { GradientGlowFilter } from './GradientGlowFilter';
import { GradientBevelFilter } from './GradientBevelFilter';
import { BlurFilter } from './BlurFilter';
import { ConvolutionFilter } from './ConvolutionFilter';
import { ColorMatrixFilter } from './ColorMatrixFilter';
import { FilterType } from '@awayfl/swf-loader';
var TYPE_FILTER_MAP = (_a = {},
    _a[FilterType.DROPSHADOW] = DropShadowFilter,
    _a[FilterType.GLOW] = GlowFilter,
    _a[FilterType.BEVEL] = BevelFilter,
    _a[FilterType.GRADIENTGLOW] = GradientGlowFilter,
    _a[FilterType.GRADIENTBEVEL] = GradientBevelFilter,
    _a[FilterType.BLUR] = BlurFilter,
    _a[FilterType.CONVOLUTION] = ConvolutionFilter,
    _a[FilterType.COLORMATRIX] = ColorMatrixFilter,
    _a);
// WE can't use imports direct from BitmapFilter because filters extends it (circular reference)
var FilterBuilder = /** @class */ (function () {
    function FilterBuilder() {
    }
    FilterBuilder.FromUntyped = function (filter, sec) {
        if (!filter || !TYPE_FILTER_MAP[filter.type]) {
            return null;
        }
        return TYPE_FILTER_MAP[filter.type].FromUntyped(filter, sec);
    };
    return FilterBuilder;
}());
export { FilterBuilder };
